import { mobileQuery } from '@globals/themes/themeConstants'
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined'
import LaunchIcon from '@mui/icons-material/LaunchOutlined'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'
import { resourceLinks } from './content/resourceContent'

type ResourcesSectionProps = {
  isGuideDismissed: boolean
  onRelaunchGuide?: () => void
}

const titleStyle = {
  margin: 0,
  [mobileQuery]: {
    margin: 0,
  },
}

const ResourcesSection: React.FC<ResourcesSectionProps> = ({
  isGuideDismissed,
  onRelaunchGuide,
}) => {
  return (
    <Card sx={{ p: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <DescriptionIcon />
        <Typography variant="h2" sx={titleStyle}>
          <T _str="Resources" />
        </Typography>
      </Stack>
      {resourceLinks.map(resource => (
        <Stack
          direction="column"
          alignItems="flex-start"
          spacing={1}
          key={resource.key}
          sx={{ mt: 2 }}>
          <Button
            id={`btnResource-${resource.key}`}
            variant="text"
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<LaunchIcon />}>
            {resource.title}
          </Button>
          <Typography variant="body1" color="text.secondary">
            {resource.description}
          </Typography>
        </Stack>
      ))}
      {isGuideDismissed && (
        <Stack direction="row" alignItems="center" sx={{ mt: 2 }}>
          <Button id="btnLaunchGuide" variant="text" onClick={onRelaunchGuide}>
            <T _str="Platform setup guide" />
          </Button>
          <Typography variant="body1" color="text.secondary" sx={{ ml: 1 }}>
            <T _str="Relaunch the in-platform guide to walk through setup steps" />
          </Typography>
        </Stack>
      )}
    </Card>
  )
}

export default ResourcesSection
